import styled from "@emotion/styled";

const CustomLabel = styled("label")`
  color: #376fd0;
  font-size: large;
  font-weight: 700;
`;

export default CustomLabel;
